import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className='img-fluid' src="/images/notfound/1.jpg" alt="" />
        </div>
    );
};

export default NotFound;